import React from "react";

import { createDispatchHook, createSelectorHook } from "react-redux";

export const headerStoreContext = React.createContext();

export const useHeaderStoreDispatch = createDispatchHook(headerStoreContext);
export const useHeaderStoreSelector = createSelectorHook(headerStoreContext);
